import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Modal, Form, Input, Select, message, Row, Col, Spin, } from 'antd'; // Checkbox , Switch
import { AddUser } from '../style';
import { BasicFormWrapper } from '../../styled';
import { getCountryData, getAllUsersData, IndustryData } from '../../../Api/Services/CommonApiService'
import { getCompanyAccount, createAccounts, FetchAllAccount } from '../../../Api/Services/AccountApiService'
import { Button } from '../../../components/buttons/buttons';
import { nameOnChangeValidator, validateDescriptionField } from '../../../components/utilities/utilities';

const { Option } = Select;

const Popup = ({ addAccount, setAddAccount, AccountApi, Callback, successMessage }) => {
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [users, setUsers] = useState([])
    const [accountData, setAccountData] = useState([])
    const [allList, setAllList] = useState([])
    // const [checked, setChecked] = useState(false)
    // const [accountTypeName, setAccountTypeName] = useState()
    const [accountInitial, setAccountInitial] = useState()
    const [allCountry, setAllCountry] = useState([])
    const [industryData, setIndustryData] = useState([])
    const [companyId, setCompanyId] = useState()
    const [uiReady, setUiReady] = useState(false)
    // const [typeData, setTypeData] = useState([])
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const handleClose = () => {
        setAddAccount(false);
    }
    const normalizeValue = (value) => {
        if (value === undefined || value === "") return null;
        return value;
    };
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };

    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    const validateCode = (_, value) => {
        const allowedRegex = /^[A-Za-z0-9-]+$/;
        if (!allowedRegex.test(value)) {
            return Promise.reject(
                new Error("Only letters, numbers, and hyphens (-) are allowed")
            );
        }
        if (value.length > 15) {
            return Promise.reject(
                new Error("Account number cannot exceed 15 characters")
            );
        }
        const existingCodes = allList.map(item => item.accountNumber)
        if (existingCodes.includes(value)) {
            return Promise.reject(new Error("This number already exists"));
        }
        return Promise.resolve();
    };
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const {
            accountname,
            accountnumber,
            parentaccount,
            accountowner,
            industry,
            country,
            description
        } = values;

        const payload = {
            companyId: normalizeValue(companyId),
            accountName: normalizeValue(accountname),
            accountNumber: normalizeValue(accountnumber),
            parentOrganization: normalizeValue(parentaccount),
            accountOwner: normalizeValue(accountowner),
            country: normalizeValue(country),
            industry: normalizeValue(industry),
            accountType: normalizeValue(1),
            customerStatus: normalizeValue("Prospective Customer"),
            description: normalizeValue(description),
            qualified: normalizeValue("Qualified"),
        }
        const updatedFields = getChangedFields(payload, accountInitial);
        try {
            const response = await createAccounts(updatedFields)
            if (response.status === 201) {
                AccountApi()
                if (response.data?.accountsId) {
                    Callback(response.data?.accountsId)
                }
                const isAutomation = response?.data?.message === AutomationMessage;
                const isApproval = response?.data?.message === ApprovalMessage;
                if (isApproval) {
                    successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                    setTimeout(() => {
                        setAddAccount(false);
                    }, 1000);
                } else if (isAutomation) {
                    successMessage("Automation rule triggered", response?.data?.message);
                    setTimeout(() => {
                        setAddAccount(false);
                    }, 1000);
                } else {
                    setAddAccount(false);
                    message.success(response?.data?.message);
                }
                loadingRef.current = false;
                setDelteClick(false)
            }
        } catch (error) {
            loadingRef.current = false;
            setDelteClick(false)
            message.error(error)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                    // <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    //     {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                    //         < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                    //         :
                    //         <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                    //             {option.firstName.slice(0, 1).toUpperCase()}
                    //         </span>
                    //     }
                    //     <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                    // </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        } catch (error) {
            message.error(error)
        }
    }
    async function IndustryDataApi() {
        try {
            const data = await IndustryData()
            const options = data.map((option, i) => (
                <Option value={option.industryId} key={i}>
                    {option.industryName}
                </Option>));
            setIndustryData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const generateUniqueCode = (Code, existingData) => {
        let newCode;
        const existingCodes = new Set(existingData.map(item => item.accountNumber));
        do {
            const randomNumber = Math.floor(100000 + Math.random() * 900000);
            newCode = `${Code}-${randomNumber}`;
        } while (existingCodes.has(newCode));
        return newCode;
    };
    const getList = async (type) => {
        try {
            const data = await getCompanyAccount()
            if (type === "Create") {
                const newCode = generateUniqueCode("AC", data);
                form.setFieldsValue({
                    accountnumber: newCode,
                })
            }
            setAllList(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            setAllCountry(response)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function AccountApis() {
        try {
            const data = await FetchAllAccount()
            const options = data.filter(item => item.account_type_name === "Customer").map((option, i) => (
                <Option value={option.account_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                    < img src={option.account_profile} alt="profile" />
                                    :
                                    <span className="image_icon AccountIcon">
                                        {option.account_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{option.account_name}</span>
                            </div>
                        </div>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                        <div>
                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.account_name.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                            <p style={{ margin: 0 }}>{option.account_number}</p>
                        </div>
                    </div>
                </Option>));
            setAccountData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const getUserDetail = async () => {
        if (profile.department === "Sales") {
            form.setFieldsValue({
                accountowner: profile.userId
            });
            setCompanyId(profile.companyId)
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            getList("Create"),
            getUserDetail(),
            getCountry(),
            AccountApis(),
            IndustryDataApi(),
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (addAccount) {
            setAccountInitial({
                companyId: normalizeValue(null),
                accountName: normalizeValue(null),
                accountNumber: normalizeValue(null),
                parentOrganization: normalizeValue(null),
                accountOwner: normalizeValue(null),
                country: normalizeValue(null),
                industry: normalizeValue(null),
                accountType: normalizeValue(null),
                customerStatus: normalizeValue(null),
                description: normalizeValue(null),
                qualified: normalizeValue(null),
            })
            fetchAll()
        }
    }, [addAccount])
    return (
        <>
            <Modal
                title="Add Sponsor"
                open={addAccount}
                onCancel={handleClose}
                maskClosable={false}
                width={700}
                footer={uiReady ? [<div className="form_action_button">
                    <Button
                        className="gray-button"
                        onClick={handleClose} size="small"
                    >
                        <FeatherIcon icon="x" />Cancel
                    </Button>
                    <Button size="small" onClick={() => form.submit()} className="button_colors" loading={deleteClick} disabled={deleteClick} >
                        {!deleteClick && <FeatherIcon icon="save" />}Save
                    </Button>
                </div>] : false}
            >
                {uiReady ? <AddUser>
                    <div className="user-info-form">
                        <Form style={{ width: '100%' }} form={form} name="info" colon={false}
                            onFinish={(values) => onSubmit(values, 'save')}
                            onFinishFailed={onFinishFailed} >
                            <BasicFormWrapper>
                                <div className="add-product-block">
                                    <Row gutter={15}>
                                        <Col xs={24}>
                                            <div className="add-product-content">
                                                <Row gutter={30} style={{ padding: "0px 20px" }}>
                                                    <Col span={12} style={{ marginBottom: 20 }} >
                                                        <Form.Item label="Account Name" name="accountname"
                                                            id="accountname"
                                                            rules={[{ required: true, message: 'Please enter account name', }, {
                                                                validator: (_, value) => {
                                                                    const error = nameOnChangeValidator(value, 50);
                                                                    if (error) {
                                                                        return Promise.reject(new Error(error));
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            }
                                                            ]}>
                                                            <Input placeholder="Enter Account Name" />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={12} style={{ marginBottom: 20 }} >
                                                        <Form.Item label="Account Number" name="accountnumber"
                                                            id="accountnumber"
                                                            rules={[{ required: true, message: 'Please enter account number', }, { validator: validateCode }]}>
                                                            <Input placeholder="Account Number" />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={12} style={{ marginBottom: 20 }} >
                                                        <Form.Item label="Parent Account" name="parentaccount"
                                                            id="parentaccount">
                                                            <Select style={{ width: '100%' }}
                                                                placeholder="Select Parent Account"
                                                                showSearch optionLabelProp="label"
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) => {
                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                        const username = String(usernameElement.props.children);
                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                    }
                                                                    return false;
                                                                }
                                                                }
                                                            >
                                                                {accountData}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={12} style={{ marginBottom: 20 }} >
                                                        <Form.Item label="Account Owner" name="accountowner"
                                                            id="accountowner" rules={[{ required: true, message: 'Please select an account owner', }]}>
                                                            <Select style={{ width: '100%' }}
                                                                placeholder="Select Account Owner"
                                                                showSearch optionLabelProp="label"
                                                                filterOption={(input, option) => {
                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                        const username = String(usernameElement.props.children);
                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                    }
                                                                    return false;
                                                                }
                                                                }>
                                                                {users}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={12} style={{ marginBottom: 20 }} >
                                                        <Form.Item label="Industry" name="industry"
                                                            id="industry" rules={[{ required: true, message: 'Please enter industry' }]}>
                                                            <Select style={{ width: '100%' }}
                                                                placeholder="Select Industry"
                                                                showSearch
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                            >
                                                                {industryData}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={12} style={{ marginBottom: 20 }} >
                                                        <Form.Item label="Country" name="country" id="country" rules={[{ message: 'Please select country', required: true }]}>
                                                            <Select
                                                                style={{ width: '100%' }}
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select Country"
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                            >
                                                                {allCountry?.map((option) => (
                                                                    <Option key={option.countryId} value={option.country}>
                                                                        {option.country}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={24} style={{ marginBottom: 20 }} >
                                                        <Form.Item label="Description" name="description" id="description" rules={
                                                            [
                                                                {
                                                                    validator: (_, value) => {
                                                                        const error = validateDescriptionField(value, 2500);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                            ]
                                                        }>
                                                            <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Description' />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </BasicFormWrapper>
                        </Form>
                    </div>
                </AddUser > :
                    <div style={{ height: "500px" }} className="spin">
                        <Spin />
                    </div>}
            </Modal >
        </>
    );
};

Popup.propTypes = {
    addAccount: PropTypes.bool.isRequired,
    setAddAccount: PropTypes.func.isRequired,
    Callback: PropTypes.func.isRequired,
    AccountApi: PropTypes.func.isRequired,
    successMessage: PropTypes.func.isRequired,
};

export default Popup;
